import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { SpinnerService } from '@services/spinner.service';
import { IDefaultSelectBoxViewModel } from '@shared/models/default-selectBox.model';
import { AuthService } from 'AuthService';
import { Roles } from '@enums/roles.enum';


@Component({
    selector: 'cz-email-button',
    templateUrl: 'email-button.component.html',
    standalone: false
})
export class EmailButtonComponent implements OnInit {

  constructor(private _ajaxService: AjaxService, private spinnerService: SpinnerService, private authService: AuthService) {
    this.onClickSend = this.onClickSend.bind(this);
    this.onClickClose = this.onClickClose.bind(this);
    this.onSenderChanged = this.onSenderChanged.bind(this);
  }

  available_Benutzer: IDefaultSelectBoxViewModel[];
  available_Gruende: IDefaultSelectBoxViewModel[];

  sig1: string;
  sig2: string;

  @ViewChild('emailForm', { static: false }) emailForm: DxFormComponent;
  @ViewChild('wiedervorlageForm', { static: false }) wiedervorlageForm: DxFormComponent;

  @Input() ownerId: number;
  @Input() entityArt: string;
  @Input() emailAdress: string;

  @Output() emailSendFinished: EventEmitter<any> = new EventEmitter<any>();
  popupVisible: boolean;
  emailData: IEmailFormDataViewModel = {} as IEmailFormDataViewModel;

  fromOptions = [
    {
      text: 'Eigene Email-Adresse verwenden',
      value: 1
    }
  ];

  ngOnInit() {
    if (this.authService.hasOneRole([Roles.Administrator])) {
      this.fromOptions.push(
        {
          text: 'Systemeigene Email-Adresse verwenden',
          value: 2
        }
      );
    }

    this.emailData.mailTo = this.emailAdress;
    this.emailData.ownerId = this.ownerId;
    this.emailData.entityArt = this.entityArt;
    this.emailData.useFrom = 1;

    this._ajaxService.get<IInitEmailVievModel>('api/Email/GetInit').subscribe(response => {
      this.sig1 = response.signatur1.content;
      this.sig2 = response.signatur2.content;
      this.emailData.signature = response.signatur1.content;
      this.available_Benutzer = response.available_Benutzer;
      this.available_Gruende = response.available_Gruende;
    });

    this.wiedervorlageData.ownerId = this.ownerId;
    this.wiedervorlageData.entityArt = this.entityArt;

    this.isWiedervorlageVisible =
      this.entityArt === 'HauptEinrichtung' ||
      this.entityArt === 'UnterEinrichtung' ||
      this.entityArt === 'AntragBe' ||
      this.entityArt === 'MeldungenEoE' ||
      this.entityArt === 'MeldepflichtenTraegerAnschrift' ||
      this.entityArt === 'MeldepflichtenEinrichtungSchliessung' ||
      this.entityArt === 'MeldepflichtenKontakte' ||
      this.entityArt === 'MeldepflichtenKonzeption' ||
      this.entityArt === 'MeldepflichtenLeitung' ||
      this.entityArt === 'MeldepflichtenBetreuung' ||
      this.entityArt === 'MeldungJaehrlich' ||
      this.entityArt === 'Antrag_Anerkennung' ||
      this.entityArt === 'Antrag_Ueberbelegung' ||
      this.entityArt === 'Traeger';
  }

  onSenderChanged(e) {
    if(e.value === 1){
      this.emailData.signature = this.sig1;
    } else {
      this.emailData.signature = this.sig2;
    }
  }

  showPopup() {
    this.popupVisible = true;
  }

  onClickClose() {
    this.popupVisible = false;
  }

  onClickSend() {
    let openTasks = 1;
    let canSendEmail = false;
    if (this.emailForm.instance.validate().isValid) {
      if (this.isWiedervorlageEnabled) {
        openTasks++;
        canSendEmail = this.wiedervorlageForm.instance.validate().isValid;
      }
      else {
        canSendEmail = true;
      }
    }
    if (canSendEmail) {
      this.spinnerService.show();

      this._ajaxService.post<IEmailFormDataViewModel>('api/Email/SendEmail', this.emailData).subscribe(response => {
        this.emailData.content = '';
        this.emailSendFinished.emit(null);
        openTasks--;
        this.canHideSpinner(openTasks);
      });

      if (this.isWiedervorlageEnabled) {
        this.spinnerService.show();
        this._ajaxService.post('api/Wiedervorlagen/AddFromEmail', this.wiedervorlageData).subscribe(response => {
          openTasks--;
          this.canHideSpinner(openTasks);
        });
      }
    }
  }

  canHideSpinner(openTasks: number) {
    if (openTasks === 0) {
      this.spinnerService.hide();
      this.popupVisible = false;
    }
  }

  isWiedervorlageVisible: boolean = false;

  isWiedervorlageEnabled: boolean = false;

  wiedervorlageData = {} as IWiedervorlageData;


}


interface IInitEmailVievModel {
  signatur1: ISignature;
  signatur2: ISignature;
  available_Benutzer: IDefaultSelectBoxViewModel[];
  available_Gruende: IDefaultSelectBoxViewModel[];
}

export interface IEmailFormDataViewModel {
  useFrom: number;
  mailTo: string;
  subject: string;
  content: string;
  signature: string;
  ownerId: number;
  entityArt: string;
}

export interface ISignature {
  userId: number;
  content: string;
}

export interface IWiedervorlageData {
  ownerId: number;
  entityArt: string;
  userId: number;
  grundId: number;
  betreff: string;
  termin: Date;
}
